import { Search, ChevronDown, ChevronUp } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

interface AccountSearchProps {
  value: string;
  onChange: (value: string) => void;
  matchCount: number;
  totalCount: number;
  onExpandAll: () => void;
  onCollapseAll: () => void;
}

/**
 * Search input with expand/collapse controls for accounts tree.
 */
export function AccountSearch({
  value,
  onChange,
  matchCount,
  totalCount,
  onExpandAll,
  onCollapseAll,
}: AccountSearchProps) {
  const isSearching = value.trim().length > 0;

  return (
    <div className="flex items-center gap-2">
      {/* Search input */}
      <div className="relative flex-1 max-w-sm">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input
          type="text"
          placeholder="Buscar por código o nombre..."
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="pl-9"
        />
      </div>

      {/* Match count when searching */}
      {isSearching && (
        <span className="text-sm text-muted-foreground">
          {matchCount} de {totalCount}
        </span>
      )}

      {/* Expand/Collapse buttons */}
      <div className="flex items-center gap-1">
        <Button
          variant="outline"
          size="sm"
          onClick={onExpandAll}
          title="Expandir todo"
        >
          <ChevronDown className="h-4 w-4" />
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={onCollapseAll}
          title="Colapsar todo"
        >
          <ChevronUp className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
